
import _ from "lodash";
import axios from "axios";
import React, {useState, useContext} from "react";
import {
  CircularProgress,
  Button
} from '@material-ui/core';
import styled from "styled-components";
import {YellowButton} from "../../ui/Button";
import {Drawer} from "../../ui/Drawer";
import {pluralize} from "../../common/Pluralize";
import { FormContext } from 'core/FormProvider';


const StyledAvailableServiceList = styled.div`
  button {
    margin: 0 5px 5px 0;
  }
  button.active {
    color: #FFFFFF;
    background: #000000;
  }
`;


export default function TariffPointServicesDrawer({point, tariffPoints, TariffPointServiceForm}) {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const [pointServices, setPointServices] = useState([]);
  const formContext = useContext(FormContext);

  const isServiceExists = (serviceId, pointId) => {
    const results = _.filter(tariffPoints, function(o) {
      return o.service.id === serviceId && o.point === pointId && !o.is_delete;
    });
    return results.length > 0;
  };

  const handleOpen = () => {
    setLoading(true);
    setOpen(true);
    axios.get(`catalog/point/${point.id}/services`).then(res => {
      setPointServices(res.data.services);
      setLoading(false);
    })
  }

  const findTariffPointServiceIndex = (serviceId, pointId) => {
    return formContext.item.tariff_points.findIndex(
      o => o.service.id === serviceId && o.point === pointId
    );
  };

  const addService = (point, service) => {
    let index = findTariffPointServiceIndex(service.id, point.id);
    if (index === -1) {
      formContext.pushArrayValue('tariff_points', {
        service: service,
        point: point.id,
        cost: 0,
      })
    }
    else if (formContext.item.tariff_points[index].is_delete === true) {
      formContext.setValue(`tariff_points.${index}.is_delete`, false);
    }
  };

  return (
    <>
      <Button
        onClick={() => handleOpen()}
        variant="outlined"
      >
        {tariffPoints.length} {pluralize(tariffPoints.length, ['услуга', 'услуги', 'услуг'])}
      </Button>

      <Drawer
        open={open}
        onClose={() => setOpen(false)}
        width={'650px'}
      >
        <h2>Услуги на точке {point.name}</h2>

        <h3>Выберите услуги</h3>

        {loading && (
          <CircularProgress />
        )}

        <StyledAvailableServiceList>
        {pointServices.map(service =>
          <Button
            key={service.id}
            onClick={() => addService(point, service)}
            variant={'outlined'}
            className={isServiceExists(service.id, point.id) ? 'active' : ''}
            disabled={!service.is_active}
          >
            {service.label}
          </Button>
        )}
        </StyledAvailableServiceList>

        {tariffPoints.length > 0 && (
          <h3>Задайте стоимость</h3>
        )}

        {tariffPoints.map((pointService, index) =>
          <TariffPointServiceForm
            key={pointService.service.id}
            index={index}
            pointService={pointService}
            context={formContext}
          />
        )}

        <div className={'mt-20'}>
          <YellowButton
            size={'large'}
            onClick={(e) => setOpen(false)}
          >
            Добавить услуги
          </YellowButton>
        </div>
      </Drawer>
    </>
  )
}